/**
 * AZ Panda Pandemic Flu Vaccine Study - Self-Contained Module
 *
 * This module contains all configuration for the AZ Panda Pandemic Flu Vaccine Study
 * in a single, easily maintainable location.
 */

import { defineStudy } from "./registry";
import { azPandaEligibleZipCodes } from "../../../data/vaccine-study-zipcodes/azPandaZipCodes";
import { azPandaScreeningQuestions } from "../../../data/pre-screener-config/AZPandaScreener";

/**
 * Common question IDs that will be asked before zipcode
 * and should be filtered out of study-specific questions
 */
const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * AZ Panda Pandemic Flu Vaccine Study
 *
 * Priority: 5 (Fifth priority - after Cidara 65+, Seqirus, Cidara 18+, and Moderna)
 * Trial ID: VHEAL0C00001-65PLUS
 * Location: Specific zipcodes in IA/NE region (106 total - 30 mile radius)
 *
 * Key criteria:
 * - Age 65+
 * - BMI <35
 * - Healthy (no major chronic conditions or immunocompromise)
 * - No history of severe vaccine allergic reactions
 * - No blood products in past 6 months
 */
export const azPandaFluStudy = defineStudy({
  id: "az-panda-flu",
  name: "AZ Panda Pandemic Flu Vaccine Study",
  trialId: "VHEAL0C00001-65PLUS",
  priority: 5,

  // Convert readonly array to regular array for compatibility
  eligibleZipCodes: Array.from(azPandaEligibleZipCodes),

  // All questions including common ones (will be filtered automatically)
  questions: azPandaScreeningQuestions,

  // Questions to filter out (already asked in common stage)
  commonQuestionIds: COMMON_QUESTION_IDS,

  // Required common answer values (age 65+)
  commonAnswerRequirements: {
    age_eligibility: ["65_or_older"],
  },

  metadata: {
    sponsor: "AstraZeneca",
    description:
      "Investigating investigational vaccines targeting pandemic influenza strains in healthy adults aged 65 and older",
  },
});
